import NodeCache from 'node-cache';

const defaultTTL = 900;
let cache = null;

function getCacheInstance(): NodeCache {
	if (!cache) {
		cache = new NodeCache();
	}

	return cache;
}

export function getCache<T = unknown>(key: string): T {
	const cacheInstance = getCacheInstance();
	return cacheInstance.get<T>(key);
}

export function getCacheKey(prefix: string, items: Array<string>): string {
	return items.reduce((cacheKey, item) => cacheKey + `_${item}`, prefix).toLowerCase();
}

export function setCache(key: string, value: unknown, ttl: number = defaultTTL): void {
	const cacheInstance = getCacheInstance();
	cacheInstance.set(key, value, ttl);
}

export function flushCache(): void {
	const cacheInstance = getCacheInstance();
	cacheInstance.flushAll();
}
